<template>
  <a
    href="https://www.facebook.com/pages/GradImages/164511703590505"
    target="_blank"
    aria-label="FaceBook"
    class="facebook-link"
  >
    <img
      :src="imgFacebookCircleLogo"
      alt="Facebook Logo"
      class="facebook-link__img"
    >
  </a>
</template>

<script>
import imgFacebookCircleLogo from '../assets/facebook-circle.png'

export default {
  name: 'FacebookLink',
  props: {
    pageData: { type: Object, default: null, required: true }
  },
  data () {
    return {
      imgFacebookCircleLogo
    }
  }
}
</script>

<style lang="scss" scoped>
.facebook-link {
  display: inline-block;

  &__img:hover {
    opacity: 0.7;
    width: 40px;
    height: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/grad-images/site-footer/components/FacebookLink.vue